import { PersonalMemo } from 'src/models/memo';

import { Callback } from 'src/util/query/models/Callback';

export class PersonalMemoCallback extends Callback<PersonalMemo | PersonalMemo[]> {
	public constructor(private readonly applyMemo: (memo: PersonalMemo) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: PersonalMemo | PersonalMemo[]): void => {
		const result = Array.isArray(successResponse) ? successResponse[0] : successResponse;

		if (result !== undefined) {
			this.applyMemo(result);
		}
	};
}
